module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"export":"Скачать отчёт на компьютер","send":"Отправить по Email","start":"Начало","end":"Окончание","test":"Поле ввода с заголовком"},"en":{"export":"Export report","send":"Send Email","start":"Start","end":"End","test":"Test title"}}')
  delete Component.options._Ctor
}
